export const mapLocationsToTuples = (locations) => {
    return locations.map((location) => [
        location.Name,
        location.Latitude,
        location.Longitude,
        location.Id,
        location.NmRadius,
        location.Zone,
        location.Performance,
    ]);
};
export const handleViewportChange = (nextViewport, setViewport) => {
    setViewport((currentViewport) => {
        if (currentViewport.zoomLevel === nextViewport.zoomLevel &&
            currentViewport.northWest?.lat === nextViewport.northWest?.lat &&
            currentViewport.northWest?.lng === nextViewport.northWest?.lng &&
            currentViewport.southEast?.lat === nextViewport.southEast?.lat &&
            currentViewport.southEast?.lng === nextViewport.southEast?.lng) {
            return currentViewport;
        }
        return nextViewport;
    });
};
